import axios from "../../lib/axiosInstance";

const get = (path, params = {}) => {
  const q = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
  );
  return axios.get(`analytics/engineer/${path}?${q}`).then((r) => r.data);
};

export const fetchEngineerKpi = (params = {}) => get("kpi", params);
export const fetchEngineerInvoiceStats = (params = {}) => get("invoiceStats", params);
